export default __webpack_public_path__ + "static/media/me-framework.bc200792.svg";